import { Component, OnInit } from '@angular/core';
import { AuthService } from './services/auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'Honest-Greens';

  constructor(private authService: AuthService) { }

  ngOnInit() {
    this.authService.autoAuthUser();

    const subscriptionType = localStorage.getItem('subscriptionType');

    if (subscriptionType == '' || subscriptionType == null) {
      localStorage.setItem('subscriptionType', 'One Delivery');
    }

    localStorage.removeItem('coupon');
  }
}
